import { Body, Container, MaterialIcon } from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import {
  CheckpointIcon,
  ConnectorLine,
  StepContainer,
  StepIndicatorContainer,
  StepLabel,
  TimelineContainer,
} from './Timeline.styles';

export interface TimelineStep {
  label: string;
  status: 'completed' | 'current' | 'upcoming';
}

interface TimelineProps {
  steps: TimelineStep[];
}

export const Timeline: React.FC<TimelineProps> = ({ steps }) => {
  const t = useTranslate();

  return (
    <Container w={'100%'}>
      <TimelineContainer>
        {steps.map((step, index) => {
          const isCompleted = step.status === 'completed';
          const isCurrent = step.status === 'current';
          const isFirst = index === 0;
          const isLast = index === steps.length - 1;

          return (
            <StepContainer key={step.label}>
              <StepIndicatorContainer>
                <ConnectorLine
                  $invisible={isFirst}
                  $isCompleted={isCompleted || isCurrent}
                  $position="left"
                />

                <CheckpointIcon $isActive={isCurrent}>
                  {isCompleted ? (
                    <MaterialIcon
                      src="check_circle"
                      color={'Icon/Success'}
                      filled
                      size={24}
                    />
                  ) : (
                    <MaterialIcon
                      src="radio_button_unchecked"
                      color={'Border/Disabled'}
                      size={24}
                    />
                  )}
                </CheckpointIcon>

                <ConnectorLine
                  $isCompleted={isCompleted}
                  $invisible={isLast}
                  $position="right"
                />
              </StepIndicatorContainer>

              <StepLabel $isCompleted={isCompleted}>
                <Body
                  size="sm"
                  weight={isCompleted ? 600 : 400}
                  color={isCompleted ? 'Text/Default' : 'Text/Disabled'}
                  data-record
                >
                  {t(step.label)}
                </Body>
              </StepLabel>
            </StepContainer>
          );
        })}
      </TimelineContainer>
    </Container>
  );
};
